// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__6MaMV","bigColWidth":"Table_bigColWidth__1zex1","biggerColWidth":"Table_biggerColWidth__J9UzN","row":"Table_row__2FNwh","col":"Table_col__2xnMX"};